import { render, staticRenderFns } from "./ModalProductsAvailablesInvoice.vue?vue&type=template&id=22b08ef8&scoped=true"
import script from "./ModalProductsAvailablesInvoice.vue?vue&type=script&lang=js"
export * from "./ModalProductsAvailablesInvoice.vue?vue&type=script&lang=js"
import style0 from "./ModalProductsAvailablesInvoice.vue?vue&type=style&index=0&id=22b08ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b08ef8",
  null
  
)

export default component.exports